// import type { Chart } from 'chart.js';
// import { useCallback, useState } from 'react';
// import { HtmlLegend } from '@/components/UI/Charts/HtmlLegend';
// import { createHtmlTooltipPlugin } from '@/components/UI/Charts/PieChart/htmlTooltipPlugin';
import { NumberAbbreviation } from '@/components/UI/NumberFormatDisplay/NumberAbbreviation';
import { useDashboardData } from '@/hooks/ReactQueryHooks/useDashboardQuery';
import type { DashboardType } from '@/types/Analytics.ts';
import { transformProjectTypeChartDataSets } from '@/utils';
import Card from '../../UI/Card/index.tsx';
// import PieChart from '../../UI/Charts/PieChart';
import PieChartECharts from '../../UI/Charts/PieChart/index1';
import { Widget } from '../constants';
import WidgetLayout from '../WidgetLayout';

export interface ConstructionTypeWidgetDataResponse {
  constructionType: string;
  _count: number;
}

export default function ConstructionTypeWidget({ dashboard }: { dashboard: DashboardType }) {
  const fetchConstructionTypeWidgetData = useDashboardData({
    dashboard,
    widget: Widget.PROJECTS_BY_CONSTRUCTION_TYPE,
  });

  // const [pieChart, setPieChart] = useState<Chart<'pie'> | null>(null);
  // const [htmlTooltipPlugin] = useState(() => createHtmlTooltipPlugin());

  // const handlePieChart = useCallback((node: Chart<'pie'>) => {
  //   setPieChart(node);
  // }, []);

  const constructionTypeWidgetData = fetchConstructionTypeWidgetData?.data?.data;
  const constructionTypeLabels = constructionTypeWidgetData?.map((data: ConstructionTypeWidgetDataResponse) => data?.constructionType);

  const projectsByConstructionType = constructionTypeWidgetData?.map((data: ConstructionTypeWidgetDataResponse) => ({
    type: data?.constructionType,
    count: data?._count,
  }));
  const constructionTypeChartDatasets = transformProjectTypeChartDataSets(projectsByConstructionType);

  const totalConstructionType = constructionTypeWidgetData?.reduce(
    (acc: number, data: ConstructionTypeWidgetDataResponse) => acc + data?._count,
    0
  );

  const constructionTypeChartData = (projectsByConstructionType ?? []).map((item: { type: string; count: number }, index: number) => ({
    value: item.count,
    name: item.type,
    color: constructionTypeChartDatasets[index]?.color,
  }));

  return (
    <WidgetLayout dashboard={dashboard} widget={Widget.PROJECTS_BY_CONSTRUCTION_TYPE}>
      <Card title='Projects By Construction Type' error={fetchConstructionTypeWidgetData.isError}>
        {constructionTypeLabels?.length > 0 ? (
          <div className='flex h-full min-h-[500px] w-full min-w-0 flex-col justify-start px-5 pt-4'>
            <div className='relative z-10 shrink-0 text-start py-2'>
              <h3 className='text-neutralColor-normal'>Total Projects</h3>
              <h1 className='m-0'>
                <NumberAbbreviation value={totalConstructionType} prefix='' />
              </h1>
            </div>

            <div className='min-w-0 w-full overflow-visible'>
              <PieChartECharts data={constructionTypeChartData} containerClassName='min-w-0 w-full' />
            </div>
          </div>
        ) : (
          <div className='flex h-full min-h-[500px] items-center justify-center p-5'>
            <h2>There are no projects by construction type.</h2>
          </div>
        )}
      </Card>
    </WidgetLayout>
  );
}
